import {PropsWithChildren} from 'react';

const Container = ({children}: PropsWithChildren<{}>) => (
    <div className="max-w-4xl mx-auto px-4">
        {children}
    </div>
);

export default Container;
